export default __webpack_public_path__ + "static/media/carousel-4-scalable-rewards-AB-test-v4.0057dc76.png";